import { lazy } from '../../../shared/deployment';

export const OfflineListener = lazy(() => import('./OfflineListener'));
export const OfflineOnlineMessage = lazy(() => import('./OfflineOnlineMessage'));
